<lottie-player *ngIf="data.reminder" class="image" src="../../assets/success.json"  style="width: 100%;height: 300px;" background="transparent"  speed="1" autoplay ></lottie-player>
<lottie-player *ngIf="!data.reminder" class="image" src="../../assets/email.json"  style="width: 100%;height: 300px;" background="transparent"  speed="1" autoplay ></lottie-player>

<div class="text-container">
    <p class="title">{{title}}</p>
    <p class="subtitle">{{subtitle}}</p>
</div>

<button mat-dialog-close  class="submit-button">Close</button>
